import { render, staticRenderFns } from "./IndustryDetail.vue?vue&type=template&id=0ecf8b89&scoped=true"
import script from "./IndustryDetail.vue?vue&type=script&lang=js"
export * from "./IndustryDetail.vue?vue&type=script&lang=js"
import style0 from "./IndustryDetail.vue?vue&type=style&index=0&id=0ecf8b89&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ecf8b89",
  null
  
)

export default component.exports